/**
 * Entry de la página `/debriefings.html` — Fase 7g.2.
 *
 * Galería tabular de debriefings (`visibility=public ∪ propios`,
 * sin atajo de admin). Clic en una fila navega a
 * `/debriefing.html?id=<id>`.
 */

import { mountDebriefingsList } from './modules/debriefings-list/mount.js';

mountDebriefingsList();
